import React, { FC } from 'react';

import UploadIcon from '@material-ui/icons/CloudUploadOutlined';

interface IProps {
  label?: string;
  helpText?: string;
  disabled?: boolean;
}

export const SelectClubPictureLabel: FC<IProps> = props => {
  const { disabled, label, helpText } = props;

  return (
    <label htmlFor={disabled ? '' : 'file-input'}>
      <UploadIcon color="primary" fontSize="large" />

      <div className="label-grey">{label}</div>

      <div className="label-red">{helpText}</div>
    </label>
  );
};
